import { array, number, object, z } from "zod";

import { LadyMinV2DTORaw } from "@/models/lady-dtos";
import { createPhotoSrcs } from "@/utils/photo.mapper.utils";

export const SearchPageLadiesResponse = object({
  count: number(),
  itemArray: array(
    LadyMinV2DTORaw.transform((ladyRawDto) => {
      return {
        ...ladyRawDto,
        photoSrcs: createPhotoSrcs(ladyRawDto.mainPhotoDTO?.mediaName, "safe"),
      };
    }),
  ),
});

type SearchPageLadiesResponse = z.infer<typeof SearchPageLadiesResponse>;
